// extracted by mini-css-extract-plugin
export var divider = "_dg-7";
export var itemsToggle = "_dg-8";
export var mergeModal = "_dg-1";
export var optionCard = "_dg-4";
export var radioGroup = "_dg-6";
export var radioOption = "_dg-0";
export var selected = "_dg-5";
export var shipmentOptions = "_dg-2";
export var tableOptions = "_dg-3";